/* eslint-disable */
/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

function Hero({ language, dataHeader = {}, breadcrump, title }) {
  const router = useRouter();
  const pathname = router.asPath.split('/').pop();

  const [breadcumbParentEn, setBreadcumbParentEn] = useState('');
  const [breadcumbParentId, setBreadcumbParentId] = useState('');

  useEffect(() => {
    breadcrump?.HeaderMenus?.forEach((item) => {
      item?.child?.forEach((secondItem) => {
        // validate if parent 2 have url (page)
        if (
          (secondItem?.hasOwnProperty('id_url') ||
            secondItem?.hasOwnProperty('en_url')) &&
          ('blogs' === secondItem?.id_url || 'blogs' === secondItem?.en_url)
        ) {
          setBreadcumbParentEn(item.en_menu_name);
          setBreadcumbParentId(item.id_menu_name);
        }
      });
    });
  }, [dataHeader]);

  return (
    <div className="top-page-detail">
      <div className="col-in-area">
        <div className="container">
          <ol className="breadcrumb">
            <Link href="/" locale={language === 'ID' ? 'id' : 'en'}>
              <li style={{ cursor: 'pointer' }}>Home</li>
            </Link>
            {language === 'EN' && breadcumbParentEn ? (
              <li>{breadcumbParentEn}</li>
            ) : (
              <></>
            )}
            {language === 'ID' && breadcumbParentId ? (
              <li>{breadcumbParentId}</li>
            ) : (
              <></>
            )}
            <li>
              <Link href={'/blogs'} locale={language === 'ID' ? 'id' : 'en'}>
                {language === 'EN'
                  ? dataHeader.en_parent_title
                  : dataHeader.id_parent_title}
              </Link>
            </li>
            <li>
              <span
                dangerouslySetInnerHTML={{
                  __html: title
                }}
              ></span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default Hero;
